import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { curPos } from './trackRec';
import { speak } from './a11y';

// cautious tour weather watch: thunder, rain/showers or gusts >= 40 km/h now or within the next 2 hours
export async function weatherRisk(lat, lon) {
  const r = await (await fetch(`https://api.open-meteo.com/v1/forecast?latitude=${lat.toFixed(3)}&longitude=${lon.toFixed(3)}&current=weather_code,wind_gusts_10m&hourly=weather_code,wind_gusts_10m,precipitation_probability&forecast_hours=3&timezone=auto`)).json();
  const h = r.hourly || {}, codes = [r.current?.weather_code, ...(h.weather_code || [])], gusts = [r.current?.wind_gusts_10m, ...(h.wind_gusts_10m || [])];
  const at = (i) => (i === 0 ? null : h.time?.[i - 1]?.slice(11));
  const it = codes.findIndex((c) => c >= 95);
  if (it >= 0) return { kind: 'thunder', at: at(it) };
  const ig = gusts.findIndex((g) => g >= 40);
  if (ig >= 0) return { kind: 'wind', at: at(ig), v: Math.round(gusts[ig]) };
  const ir = codes.findIndex((c) => (c >= 61 && c <= 67) || (c >= 80 && c <= 82));
  if (ir >= 0) return { kind: 'rain', at: at(ir) };
  return null;
}

export function useWeatherWatch(t, active) {
  const [st, setSt] = useState(null);
  useEffect(() => {
    if (!active) return undefined;
    let last = '';
    const check = async () => {
      const p = curPos();
      if (!p || !navigator.onLine) return;
      try {
        const w = await weatherRisk(p.lat, p.lon);
        setSt(w || { kind: 'ok' });
        const key = w ? `${w.kind}${w.at}` : '';
        if (w && key !== last) {
          const msg = t['wxWarn_' + w.kind].replace('{at}', w.at ? `${t.wxAt} ${w.at}` : t.wxNow).replace('{v}', w.v ?? '');
          toast.warning(msg, { duration: 20000 });
          navigator.vibrate?.([300, 150, 300, 150, 600]);
          speak(msg.replace(/[^\p{L}\p{N}\s.,:;!?°/–-]/gu, '').trim(), true);
        }
        last = key;
      } catch { /* offline */ }
    };
    const first = setTimeout(check, 4000), id = setInterval(check, 15 * 60000);
    return () => { clearTimeout(first); clearInterval(id); };
  }, [active, t]);
  return st;
}
